import React, { FC, ReactNode, CSSProperties } from 'react';

interface GridProps {
  columns: number;
  children: ReactNode | ReactNode[];
  style?: CSSProperties;
}

const Grid: FC<GridProps> = ({ children, columns }) => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridGap: 10,
        maxWidth: '100%',
        // margin: 'auto',
      }}
    >
      {children}
    </div>
  );
};

export default Grid;
